module.exports = __webpack_public_path__ + "img/62.78095be9.jpg";